import React, { useEffect, useState } from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import moment from 'moment/moment'
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import swal from "sweetalert";
import { serverInfo } from '../../../../App';
import { useContext } from 'react';
function Participate({ item, chatInfo, setChatInfo, enrollIndex, setEnrollIndex, index, setHandelSendStatus, timeInterval, from }) {
    console.log({ item, chatInfo, setChatInfo, enrollIndex, setEnrollIndex, index, setHandelSendStatus, timeInterval, from })
    const { imageCdnUrl } = useContext(serverInfo);

    const [startTime, setStartTime] = useState(false)
    const [sendStatus, setSendStatus] = useState(true)

    const remaininingSeconds = item?.remaining_seconds ?? 0;

    const ChatJoin = (data) => {
        setChatInfo(data);
        if (item.publish_status !== 0) {
            setStartTime(true)
        }
        setHandelSendStatus(sendStatus)
    };

    /**
     * navigate to an other user
     */
    const timesUp = () => {

        let eventTimeInterval = timeInterval ? timeInterval : 0

        // alert(eventTimeInterval)
        toast.info(item?.user.first_name + " " + item?.user.last_name + "'s time is finished", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        setSendStatus(false)
        if (timeInterval) {
            toast("An other user join with in " + eventTimeInterval + " minute", {
                position: "top-right",
                autoClose: 60000 * eventTimeInterval,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }

        const myTimeout = setTimeout(handelGoAnotherUser, 60000 * eventTimeInterval);
        handelUserStatusUpdate(item?.id)
        setHandelSendStatus(false)
    }

    /**
     * navigate an other user
     */
    const handelGoAnotherUser = () => {
        setEnrollIndex(enrollIndex + 1)
    }


    // function myStopFunction() {
    //     clearTimeout(myTimeout);
    // }

    useEffect(() => {
        if (enrollIndex === index) {

            setStartTime(true)
        }
    }, [enrollIndex])

    useEffect(() => {
        if (item.publish_status === 0) {
            setSendStatus(false)
        }
        
    }, [item])

    /**
     * enroll user status update 
     */
    const handelUserStatusUpdate = ($id) => {
        if (from == 'star') {

            axios.get(`/api/star/qna_enrolluser_status_update/${$id}`).then((res) => {
                
            }).catch((err) => {
                
            })
        }
    }


    const timeCount = () => {
        let dateTime = item.qna_date.split(" ")
        let eventDate = dateTime[0]
        let startTime = item.qna_start_time
        let endTime = item.qna_end_time


        let start = moment(eventDate + " " + startTime)
        let end = moment(eventDate + " " + endTime)
        

        return end.valueOf() - start.valueOf()
    }
    // let minute = timeCount() / 60000
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
      };

    return (

        <div
            className={
                item?.id === chatInfo?.id
                    ? "card rounded-0 bg-Message-unread  mb-2 px-2 py-1 bg-warning"
                    : "card rounded-0 bg-Message-unread  mb-2 px-2 py-1"
            }
            style={{ cursor: "pointer" }}
            onClick={() => ChatJoin(item)}
        >
            <div className="d-flex align-items-center custom-relative-message rounded justify-content-between">
                <div className="d-flex align-items-center">
                    <img
                        src={imageCdnUrl + item?.user?.image}
                        alt=""
                        className="UserMessage me-2"
                    />
                    {/* <span className="user-active-message"></span> */}
                    <span className="user-name-device">
                        {" "}
                        {item?.user.first_name + " " + item?.user.last_name}

                    </span>
                    
                </div>
                <span className="user-name-device bg-dark p-2 rounded">

                    {"Remaining: " + formatTime(remaininingSeconds)}

                </span>
                {/* timeCount() / 1000 */}
                {/* {from == "star" &&
                    <div style={{ display: 'flex', width: '50%', justifyContent: 'flex-end' }}>
                        {remaininingSeconds &&
                            <CountdownCircleTimer
                                size={50}
                                strokeWidth={5}
                                isPlaying={false}
                                duration={timeCount() / 1000}
                                colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                                colorsTime={[7, 5, 2, 0]}

                                onComplete={timesUp}
                            >
                                {({ remainingTime }) => remaininingSeconds}
                            </CountdownCircleTimer>
                        }
                    </div>
                } */}
            </div>
            <ToastContainer />
        </div>
    )
}

export default Participate